import {
  ListRegionsAndDistrictsQuery,
  Account_Set_Input
} from 'src/config/generated/graphql'

import { UpdateAccountDetailsFormValues } from './types'

export const transformFormData = (
  values: UpdateAccountDetailsFormValues,
  regionsAndDistricts: ListRegionsAndDistrictsQuery
): Account_Set_Input => {
  const region = values.RegionId
    ? regionsAndDistricts.Region.find(r => r.Id === values.RegionId)
    : null
  const district = values.DistrictId
    ? regionsAndDistricts.District.find(d => d.Id === values.DistrictId)
    : null

  return {
    BusinessType: values.BusinessType,
    Description: values.Description,
    DistrictId: values.DistrictId,
    DistrictName: district?.Name,
    FocusArea: values.FocusArea,
    GovType: values.GovType,
    Mobile: values.Mobile?.toString(),
    Name: values.Name,
    OrgType: values.OrgType,
    Phone: values.Phone?.toString(),
    RegionName: region?.Name,
    RegionRef: region?.Reference,
    RegionId:
      values.RegionId && values.RegionId !== 'none' ? values.RegionId : null,
    SchoolType: values.SchoolType,
    Sector: values.Sector,
    Type: values.Type,
    ContactFirstname: values.ContactFirstname,
    ContactLastname: values.ContactLastname,
    Department: values.Department,
    BusinessSize: values.BusinessSize,
    Email: values.Email
  }
}
